/**
 * a2-reviews.js — Judge.me reviews for the A2 template (sections/a2-reviews.liquid).
 * Spec: docs/a2/02-BEHAVIOUR.md §11. Reads Judge.me's public widget endpoint (the
 * same source assets/mm-reviews.js uses) and renders the A2 markup with client-side
 * filters over a pool of up to 200 reviews. Exposes window.A2Reviews.render(productId).
 *
 * Custom-form answers arrive as review.cf_answers [{question_title, value}], e.g.
 *   "Youswim size": "Stretch I", "Dress size": "US 10 (UK 14)", "Cup size": "D", "Height": "5’7 - 6’0"
 */
(function () {
  'use strict';
  if (window.A2Reviews) return;

  var PER_PAGE = 50, MAX_PAGES = 4;
  var CUP_E_PLUS = /^(dd\/?e|e|f|ff|g|gg|g\+|h|hh|j|e\+|f\+)$/i;
  var PREG = /pregnan|bump|postpartum|post-partum|maternity|nursing|breastfeed/i;
  var mqDesktop = window.matchMedia('(min-width: 1024px)');
  var state = { productId: null, pool: [], filter: 'all', shown: 0, total: 0, loading: null, loaded: false };

  function root() { return document.querySelector('[data-a2-reviews]'); }
  function $(s, r) { return (r || document).querySelector(s); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cfg() { var el = $('[data-a2-reviews-config]', root()); try { return JSON.parse(el.textContent); } catch (e) { return {}; } }
  function answer(r, re) {
    var a = (r.cf_answers || []).filter(function (x) { return re.test(x.question_title || ''); })[0];
    return a ? String(a.value || '').trim() : '';
  }
  // The reviewer's usual size as a US number. Answers look like "US 10 (UK 14)" (USD store);
  // a UK or AU answer ("UK 14", "AU 14") is read as US = UK − 4.
  function usualUS(dress) {
    var m = dress.match(/US\s*(\d+)/i); if (m) return m[1];
    m = dress.match(/(?:UK|AU)\s*(\d+)/i); return m ? String(parseInt(m[1], 10) - 4) : '';
  }
  function sizeLabel(us) {
    var z = cfg().sizing || { label: 'US', offset: 0 };
    return z.label + ' ' + (parseInt(us, 10) + (z.offset || 0));
  }
  function info(r) {
    var dress = answer(r, /dress size|usual/i), m = [null, usualUS(dress)];
    // Cup answers are bare letters ("A", "DD", "38HH"); show them as "A cup".
    var cup = answer(r, /cup/i);
    if (cup && !/cup/i.test(cup)) cup += ' cup';
    return { stretch: answer(r, /youswim size|stretch/i), us: m[1] || '', cup: cup };
  }
  function shopDomain() {
    var r = root();
    return (window.jdgm && window.jdgm.shopDomain) || (window.jdgmSettings && window.jdgmSettings.shop_domain) || (r && r.dataset.shop) || location.hostname;
  }
  function fetchPage(productId, page) {
    var shop = shopDomain();
    var url = 'https://judge.me/reviews/reviews_for_widget?url=' + shop + '&shop_domain=' + shop + '&platform=shopify&page=' + page +
      '&per_page=' + PER_PAGE + '&sort_key=rating&sort_dir=desc&product_id=' + productId;
    return fetch(url).then(function (r) { return r.json(); });
  }
  // Each load gets a token; responses from an older load (e.g. the previous product's later
  // pages still arriving after a style switch) are dropped instead of merged into this pool.
  var loadSeq = 0;
  function loadPool(productId) {
    var seq = ++loadSeq;
    state.productId = productId; state.pool = []; state.gallery = []; state.loading = null; state.loaded = false; state.total = 0; state.avg = 0;
    var current = function () { return seq === loadSeq; };
    var p = fetchPage(productId, 1).then(function (d) {
      if (!current()) return;
      state.total = parseInt(d.number_of_reviews, 10) || 0;
      state.avg = d.average_rating;
      state.pool = d.reviews || [];
      state.gallery = d.photo_gallery || [];
      var pages = Math.min(MAX_PAGES, (d.pagination && d.pagination.total_pages) || 1), rest = [];
      for (var i = 2; i <= pages; i++) rest.push(fetchPage(productId, i));
      return Promise.all(rest).then(function (all) {
        if (!current()) return;
        all.forEach(function (x) { state.pool = state.pool.concat(x.reviews || []); });
        state.loaded = true;
      });
    });
    state.loading = p;
    return p;
  }
  function matches(r, f) {
    var i = info(r);
    switch (f) {
      case 's1': return /^stretch i$/i.test(i.stretch) || (!i.stretch && /stretch i(?!i)/i.test(r.product_variant_title || ''));
      case 's2': return /^stretch ii$/i.test(i.stretch) || (!i.stretch && /stretch ii/i.test(r.product_variant_title || ''));
      case 'cup': return CUP_E_PLUS.test(i.cup);
      case 'preg': return PREG.test((r.title || '') + ' ' + (r.body_html || ''));
      case 'photos': return (r.pictures_urls || []).length > 0;
      default: return true;
    }
  }
  function fmtDate(s) {
    var d = new Date(String(s).replace(' UTC', 'Z').replace(' ', 'T'));
    // US store: "Oct 13, 2026"; UK/AU: "13 Oct 2026".
    var loc = (cfg().sizing || {}).label === 'US' || !(cfg().sizing) ? 'en-US' : 'en-GB';
    return isNaN(d) ? '' : d.toLocaleDateString(loc, { month: 'short', day: 'numeric', year: 'numeric' });
  }
  function stars(n) {
    var out = ''; for (var i = 0; i < 5; i++) out += '<svg width="13" height="13" viewBox="0 0 24 24" aria-hidden="true" style="opacity:' + (i < n ? 1 : .25) + '"><path fill="currentColor" d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6-4.9-4.6 6.6-.8z"/></svg>';
    return '<span class="ys-stars" role="img" aria-label="' + n + ' / 5">' + out + '</span>';
  }
  // Photos and videos on a review, in one list for the viewer. Judge.me sends photos as
  // pictures_urls, Judge.me-hosted videos as media_platform_hosted_video_infos and
  // YouTube uploads as video_external_ids.
  function media(r) {
    var out = (r.pictures_urls || []).map(function (p) { return { type: 'photo', src: p.huge || p.original, thumb: p.compact || p.small }; });
    (r.media_platform_hosted_video_infos || []).forEach(function (v) {
      var src = v.url || v.video_url || v.mp4_url || v.playback_url || v.src;
      if (src) out.push({ type: 'video', src: src, thumb: v.thumbnail_url || v.thumbnail || v.poster_url || '' });
    });
    (r.video_external_ids || []).forEach(function (id) { if (id) out.push({ type: 'youtube', src: 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&playsinline=1', thumb: 'https://i.ytimg.com/vi/' + encodeURIComponent(id) + '/mqdefault.jpg' }); });
    return out;
  }
  function byUuid(id) { for (var i = 0; i < state.pool.length; i++) if (state.pool[i].uuid === id) return state.pool[i]; return null; }

  // Simple media viewer: tap the backdrop or the photo, the × button, swipe down or Esc to close.
  // Arrows / swipe left-right step through a review's other photos.
  var Lightbox = {
    el: null, items: [], i: 0, opener: null,
    build: function () {
      if (this.el) return this.el;
      var d = document.createElement('dialog');
      d.className = 'a2-lightbox';
      d.setAttribute('aria-label', 'Review photo');
      d.innerHTML = '<div class="a2-lightbox__stage" data-a2-lb-stage></div>' +
        '<button type="button" class="a2-lightbox__close" data-a2-lb-close aria-label="Close"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<button type="button" class="a2-lightbox__nav a2-lightbox__nav--prev" data-a2-lb-step="-1" aria-label="Previous"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg></button>' +
        '<button type="button" class="a2-lightbox__nav a2-lightbox__nav--next" data-a2-lb-step="1" aria-label="Next"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button>' +
        '<span class="a2-lightbox__count" data-a2-lb-count></span>';
      document.body.appendChild(d);
      var self = this;
      d.addEventListener('click', function (e) {
        var step = e.target.closest('[data-a2-lb-step]');
        if (step) { self.show(self.i + parseInt(step.dataset.a2LbStep, 10)); return; }
        // Anything but a video or YouTube player closes: backdrop, the photo itself, the × button.
        // (Not after a mouse drag that stepped to another photo.)
        if (self.suppressClick) { self.suppressClick = false; return; }
        if (!e.target.closest('video, iframe')) self.close();
      });
      d.addEventListener('cancel', function (e) { e.preventDefault(); self.close(); });
      d.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') self.show(self.i + 1);
        if (e.key === 'ArrowLeft') self.show(self.i - 1);
      });
      var x0 = null, y0 = null;
      d.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      d.addEventListener('touchend', function (e) {
        if (x0 == null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
        if (Math.abs(dy) > 60 && Math.abs(dy) > Math.abs(dx)) { self.close(); return; }
        if (Math.abs(dx) > 50 && self.items.length > 1) self.show(self.i + (dx < 0 ? 1 : -1));
      });
      // Desktop: drag with the mouse, or two-finger swipe on a trackpad, to step through.
      var px = null, dragged = false;
      d.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse' && !e.target.closest('video, iframe, button')) { px = e.clientX; dragged = false; } });
      d.addEventListener('pointermove', function (e) { if (px != null && Math.abs(e.clientX - px) > 8) dragged = true; });
      d.addEventListener('pointerup', function (e) {
        if (px == null) return; var dx = e.clientX - px; px = null;
        if (Math.abs(dx) > 50 && self.items.length > 1) {
          // Swallow only the click this drag produces (it fires right after pointerup), never a later tap.
          self.suppressClick = true; setTimeout(function () { self.suppressClick = false; }, 0);
          self.show(self.i + (dx < 0 ? 1 : -1));
        }
      });
      d.addEventListener('dragstart', function (e) { e.preventDefault(); });
      var wheelAcc = 0, wheelLock = 0;
      d.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY) || self.items.length < 2) return;
        e.preventDefault();
        if (Date.now() < wheelLock) return;
        wheelAcc += e.deltaX;
        if (Math.abs(wheelAcc) > 50) { self.show(self.i + (wheelAcc > 0 ? 1 : -1)); wheelAcc = 0; wheelLock = Date.now() + 500; }
      }, { passive: false });
      this.el = d;
      return d;
    },
    open: function (items, i, opener) {
      var d = this.build(); this.items = items; this.opener = opener;
      d.classList.toggle('is-multi', items.length > 1);
      this.show(i);
      if (!d.open) d.showModal();
      document.documentElement.classList.add('ys-scroll-lock');
    },
    show: function (i) {
      var n = this.items.length; if (!n) return;
      this.i = (i + n) % n;
      var m = this.items[this.i], stage = this.el.querySelector('[data-a2-lb-stage]');
      stage.innerHTML = m.type === 'photo' ? '<img class="a2-lightbox__media" src="' + esc(m.src) + '" alt="">'
        : m.type === 'video' ? '<video class="a2-lightbox__media" src="' + esc(m.src) + '" controls autoplay playsinline></video>'
        : '<iframe class="a2-lightbox__media a2-lightbox__yt" src="' + esc(m.src) + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen title="Review video"></iframe>';
      this.el.querySelector('[data-a2-lb-count]').textContent = n > 1 ? (this.i + 1) + ' / ' + n : '';
    },
    close: function () {
      if (!this.el || !this.el.open) return;
      this.el.querySelector('[data-a2-lb-stage]').innerHTML = '';
      this.el.close();
      document.documentElement.classList.remove('ys-scroll-lock');
      if (this.opener && document.contains(this.opener)) this.opener.focus({ preventScroll: true });
    }
  };

  function card(r, c) {
    var i = info(r), who = ['<span class="a2-review__name">' + esc(r.reviewer_name) + '</span>'];
    if (c.showSizes !== false) {
      if (i.us || i.cup) who.push('<span>Usually ' + esc([i.us ? sizeLabel(i.us) : '', i.cup].filter(Boolean).join(' · ')) + '</span>');
      if (i.stretch) who.push('<span>Wears ' + esc(i.stretch) + '</span>');
    }
    if (r.verified_buyer) who.push('<span>✓ ' + esc(c.verifiedLabel || 'Verified') + '</span>');
    var body = String(r.body_html || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
    // Judge.me fills missing titles with the first words of the review ("Love it! So
    // comfortable and"). Treat those as no title, so the review text itself is shown.
    var norm = function (x) { return String(x || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); };
    var autoTitle = !r.title || (norm(body).indexOf(norm(r.title)) === 0 && norm(r.title).length < norm(body).length);
    var title = autoTitle ? '' : r.title;
    var photos = media(r).map(function (m, k) {
      return '<button type="button" class="a2-review__thumb' + (m.type === 'video' ? ' is-video' : '') + '" data-a2-rv-media="' + esc(r.uuid) + '" data-a2-rv-index="' + k + '" aria-label="' + (m.type === 'video' ? 'Play video' : 'View photo') + '">' +
        (m.thumb ? '<img src="' + esc(m.thumb) + '" alt="" loading="lazy" width="64" height="64">' : '<span class="a2-review__thumb-ph"></span>') + '</button>';
    }).join('');
    return '<article class="a2-review' + (autoTitle ? ' a2-review--untitled' : '') + '" data-a2-review>' +
      '<div class="a2-review__meta">' + stars(parseInt(r.rating, 10) || 0) + '<span>' + fmtDate(r.created_at) + '</span></div>' +
      (title ? '<h3 class="a2-review__title ys-text-face">' + esc(title) + '</h3>' : '') +
      '<p class="a2-review__body">' + esc(body) + '</p>' +
      // "Read more" when the text is clamped: 4 lines on mobile (~200 chars), 6 on desktop (~420).
      (body.length > 200 ? '<button type="button" class="a2-review__more' + (body.length > 420 ? '' : ' a2-review__more--m') + '" data-a2-rv-expand>' + esc(c.readMoreLabel || 'Read more') + '</button>' : '') +
      (photos ? '<div class="a2-review__photos">' + photos + '</div>' : '') +
      '<div class="a2-review__who">' + who.join('') + '</div></article>';
  }
  function list() { return state.pool.filter(function (r) { return matches(r, state.filter); }); }
  // Customer photo gallery: every photo/video from Judge.me's photo_gallery plus the loaded pool,
  // newest review first, de-duplicated by review. Tiles up to the per-breakpoint max; the last
  // tile shows "+N" when there are more, and every tile opens the viewer on the full set.
  function galleryItems() {
    var seen = {}, items = [];
    (state.gallery || []).concat(state.pool).forEach(function (r) {
      if (!r || seen[r.uuid]) return; seen[r.uuid] = true;
      media(r).forEach(function (m) { items.push(m); });
    });
    return items;
  }
  function paintGallery() {
    var r = root(), box = r && $('[data-a2-rv-gallery]', r); if (!box) return;
    var grid = $('[data-a2-rv-gallery-grid]', box), items = galleryItems();
    var max = parseInt(mqDesktop.matches ? box.dataset.maxDesktop : box.dataset.maxMobile, 10) || 9;
    box.hidden = !items.length;
    var shown = items.slice(0, max), extra = items.length - shown.length, label = cfg().galleryMoreLabel || '+[count]';
    grid.innerHTML = shown.map(function (m, k) {
      var more = extra > 0 && k === shown.length - 1;
      return '<button type="button" class="a2-rv-gallery__tile' + (m.type !== 'photo' ? ' is-video' : '') + '" data-a2-rv-gal="' + k + '" aria-label="' + (m.type !== 'photo' ? 'Play video' : 'View photo') + ' ' + (k + 1) + ' of ' + items.length + '">' +
        (m.thumb ? '<img src="' + esc(m.thumb) + '" alt="" loading="lazy">' : '') +
        (more ? '<span class="a2-rv-gallery__more">' + esc(label.replace('[count]', extra + 1)) + '</span>' : '') + '</button>';
    }).join('');
  }
  if (mqDesktop.addEventListener) mqDesktop.addEventListener('change', paintGallery);

  function paint(reset) {
    var r = root(); if (!r) return;
    var c = cfg(), items = list();
    if (reset) state.shown = mqDesktop.matches ? (c.initialDesktop || 3) : (c.initialMobile || 2);
    var visible = items.slice(0, state.shown);
    $('[data-a2-rv-list]', r).innerHTML = visible.map(function (x) { return card(x, c); }).join('');
    $('[data-a2-rv-empty]', r).hidden = items.length > 0;
    var more = $('[data-a2-rv-more]', r);
    var poolExhausted = state.filter === 'all' ? state.shown >= state.total : state.shown >= items.length;
    more.hidden = poolExhausted || items.length === 0;
    if (state.shown > (mqDesktop.matches ? c.initialDesktop : c.initialMobile)) more.textContent = c.moreLabel;
    var st = $('[data-a2-rv-status]', r);
    if (st) st.textContent = String(c.resultsLabel || 'Showing [count] reviews').replace('[count]', items.length);
    var avg = $('[data-a2-rv-avg]', r), cnt = $('[data-a2-rv-count]', r);
    // Always overwrite (also with 0), so a switch to a product with no reviews never keeps the last count.
    if (avg) avg.textContent = (Math.round((parseFloat(state.avg) || 0) * 10) / 10).toFixed(1);
    if (cnt) cnt.textContent = state.total;
    r.classList.toggle('is-none', state.loaded && state.total === 0 && state.pool.length === 0);
    paintGallery();
  }
  function render(productId) {
    var r = root(); if (!r) return;
    productId = String(productId || r.dataset.productId);
    state.filter = 'all';
    loadPool(productId).then(function () { if (state.productId === productId) paint(true); }).catch(function () { if (state.productId === productId) paint(true); });
  }
  document.addEventListener('click', function (e) {
    var r = root(); if (!r || !r.contains(e.target)) return;
    var f = e.target.closest('[data-a2-rv-filter]');
    if (f) {
      state.filter = f.dataset.a2RvFilter;
      r.querySelectorAll('.a2-reviews__chips [data-a2-rv-filter]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.a2RvFilter === state.filter ? 'true' : 'false'); });
      paint(true);
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'pdp_review_filter', filter: state.filter }); } catch (x) {}
      return;
    }
    var gt = e.target.closest('[data-a2-rv-gal]');
    if (gt) { Lightbox.open(galleryItems(), parseInt(gt.dataset.a2RvGal, 10) || 0, gt); return; }
    var th = e.target.closest('[data-a2-rv-media]');
    if (th) {
      // Open on the full set of customer media (same as the gallery), at the tapped item, so the
      // arrows / swipe browse every photo, not just this review's.
      var rv = byUuid(th.dataset.a2RvMedia); if (!rv) return;
      var mine = media(rv)[parseInt(th.dataset.a2RvIndex, 10) || 0], all = galleryItems(), at = 0;
      for (var q = 0; q < all.length; q++) if (mine && all[q].src === mine.src) { at = q; break; }
      Lightbox.open(all.length ? all : media(rv), at, th);
      return;
    }
    if (e.target.closest('[data-a2-rv-more]')) { state.shown += cfg().pageSize || 6; paint(false); return; }
    var ex = e.target.closest('[data-a2-rv-expand]');
    if (ex) { ex.closest('[data-a2-review]').classList.add('is-expanded'); ex.remove(); return; }
    var art = e.target.closest('[data-a2-review]');
    if (art && !mqDesktop.matches && !e.target.closest('a, button')) art.classList.toggle('is-expanded');
  });
  // A style switch re-renders this section from the server with an empty list. Repaint from
  // the pool for the same product (it may already have loaded), or load the new product's.
  document.addEventListener('a2:section-refreshed', function () {
    var r = root(); if (!r) return;
    if (r.dataset.productId !== state.productId) render(r.dataset.productId);
    else if (state.loading) state.loading.then(function () { paint(true); }, function () { paint(true); });
    else paint(true);
  });

  window.A2Reviews = { render: render, _state: state };
  function boot() { if (root()) render(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
